"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withSliderContext", {
  enumerable: true,
  get: function get() {
    return _withSliderContext.default;
  }
});
exports.default = exports.SliderContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Bar = _interopRequireDefault(require("./Bar"));

var _Input = _interopRequireDefault(require("./Input"));

var _withSliderContext = _interopRequireDefault(require("./withSliderContext"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SliderContext = (0, _react.createContext)({
  onChange: function onChange() {},
  onDragStart: function onDragStart() {},
  onTrackClick: function onTrackClick() {},
  onInputChange: function onInputChange() {},
  knobPos: null,
  highlightStyles: null,
  value: null,
  knobRef: null,
  trackRef: null,
  step: null,
  vertical: false,
  min: null,
  max: null,
  multiple: false,
  ref: null
});
exports.SliderContext = SliderContext;

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getInitInfo", function () {
      // get initial knob position and highlight prop
      var _this$props = _this.props,
          max = _this$props.max,
          multiple = _this$props.multiple,
          vertical = _this$props.vertical;
      var value = _this.state.value; // get initial slider info

      var knobNode = _this.knobRef.current;
      var trackNode = _this.trackRef.current;
      var track = trackNode.getBoundingClientRect();
      var knob = {
        width: knobNode.getBoundingClientRect().width,
        maxLeft: track.width - knobNode.getBoundingClientRect().width,
        // vertical
        height: knobNode.getBoundingClientRect().height,
        maxTop: track.height - knobNode.getBoundingClientRect().height
      };
      var finalPos = vertical ? (0, _lib.getPercentageValue)(knob.maxTop, _this.calcStepPercentage()) : (0, _lib.getPercentageValue)(knob.maxLeft, _this.calcStepPercentage());
      var step = {
        pos: finalPos,
        value: _this.calcStep(),
        percentage: _this.calcStepPercentage()
      };
      var sliderInfoKnobMaxValue = vertical ? knob.maxTop : knob.maxLeft;

      if (multiple) {
        if (_this.validateMultipleValue(value)) {
          var mappedPercentage = value.map(function (v) {
            return (0, _lib.convertToPercentage)(v, max);
          });
          var mappedKnobPos = mappedPercentage.map(function (p) {
            return (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, p);
          }); // last one minus first one to get total highlight width percentage

          var highlightPercentage = mappedPercentage[mappedPercentage.length - 1] - mappedPercentage[0];
          var newKnobPos = [];
          mappedKnobPos.forEach(function (pos, i) {
            var knobPosObj = {
              key: i,
              offset: null,
              pos: pos
            };
            newKnobPos.push(knobPosObj);
          });

          _this.setState({
            knobPos: newKnobPos,
            highlightStyles: {
              pos: mappedKnobPos[0],
              percentage: highlightPercentage
            }
          });
        }
      }

      if (_this.validateValue(value)) {
        var currentPercentage = (0, _lib.convertToPercentage)(value, max);
        var knobPos = (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, currentPercentage);

        _this.setState({
          knobPos: {
            offset: null,
            pos: knobPos
          },
          highlightStyles: {
            percentage: currentPercentage
          }
        });
      } // will use these informations to calculate


      _this.setState({
        sliderInfo: {
          track: track,
          knob: knob,
          step: step
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getPositionOnChange", function (value) {
      var vertical = _this.props.vertical;
      var sliderInfo = _this.state.sliderInfo;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;

      if (value < 0) {
        return 0;
      } else if (value > sliderInfoKnobMaxValue) {
        return sliderInfoKnobMaxValue;
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getMultiplePositionOnChange", function (value) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var vertical = _this.props.vertical;
      var _this$state = _this.state,
          sliderInfo = _this$state.sliderInfo,
          knobPos = _this$state.knobPos;
      var sliderInfoKnobLengthValue = vertical ? sliderInfo.knob.height : sliderInfo.knob.width;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft; // if not first one

      if (index !== 0) {
        if (value < knobPos[index - 1].pos + sliderInfoKnobLengthValue) {
          return knobPos[index - 1].pos + sliderInfoKnobLengthValue;
        }
      } // if not last one


      if (index !== _this.state.value.length - 1) {
        if (value > knobPos[index + 1].pos - sliderInfoKnobLengthValue) {
          return knobPos[index + 1].pos - sliderInfoKnobLengthValue;
        }
      } // less than 0


      if (value < 0) {
        return 0;
      } // max value


      if (value > sliderInfoKnobMaxValue) {
        return sliderInfoKnobMaxValue;
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getMultipleSnapPosition", function (value) {
      var vertical = _this.props.vertical;
      var _this$state2 = _this.state,
          sliderInfo = _this$state2.sliderInfo,
          knobPos = _this$state2.knobPos,
          index = _this$state2.index;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft; // if not first one

      if (index !== 0) {
        // value must be bigger than the prev pos, and smaller than prev pos + one step pos
        if (value > knobPos[index - 1].pos && value < knobPos[index - 1].pos + sliderInfo.step.pos) {
          return knobPos[index - 1].pos + sliderInfo.step.pos;
        }
      } // if not last one


      if (index !== _this.state.value.length - 1) {
        // value must be smaller than the next pos, and bigger than next pos - one step pos
        if (value < knobPos[index + 1].pos && value > knobPos[index + 1].pos - sliderInfo.step.pos) {
          return knobPos[index + 1].pos - sliderInfo.step.pos;
        }
      } // less than 0


      if (value < 0) {
        return 0;
      } // max value


      if (value > sliderInfoKnobMaxValue) {
        return sliderInfoKnobMaxValue;
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getInitValue", function (value) {
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max;

      var step = _this.calcStep();

      if ((0, _lib.arrayHasItems)(value)) {
        (0, _lib.sortAscending)(value);
        var newValue = [];
        value.forEach(function (v, index) {
          if (newValue[index - 1] && v <= newValue[index - 1]) {
            // current value smaller or same as previous value, return the previous value + 1 step
            newValue.push(newValue[index - 1] + step);
            return;
          }

          if (v < min) {
            newValue.push(min);
            return;
          }

          if (v > max) {
            newValue.push(max);
            return;
          }

          if (v % step !== 0) {
            newValue.push((0, _lib.getMultiplierCeil)(v, step));
            return;
          }

          newValue.push(v);
        });
        return newValue;
      }

      if (value < min) return min;
      if (value > max) return max;
      if (value % step !== 0) return (0, _lib.getMultiplierRounded)(value, step);
      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "validateMultipleValue", function (valueArr) {
      return (0, _lib.arrayHasItems)(valueArr) && (0, _lib.isAscending)(valueArr) && valueArr.every(function (v) {
        return _this.validateValue(v);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateValue", function (value) {
      var _this$props3 = _this.props,
          min = _this$props3.min,
          max = _this$props3.max,
          step = _this$props3.step;
      return (0, _lib.isNumber)(value) && value % (step || _this.state.step) === 0 && value >= min && value <= max;
    });

    _defineProperty(_assertThisInitialized(_this), "validateStep", function (step) {
      var _this$props4 = _this.props,
          min = _this$props4.min,
          max = _this$props4.max;
      var total = max - min;
      return (0, _lib.isNumber)(step) && step > 0 && total % step === 0;
    });

    _defineProperty(_assertThisInitialized(_this), "calcValue", function (percentage) {
      var max = _this.props.max;
      return max / 100 * percentage;
    });

    _defineProperty(_assertThisInitialized(_this), "validateValueOnChange", function (v, index) {
      var value = _this.state.value;

      if (index === 0) {
        return v !== value[index] && v < value[index + 1];
      }

      if (index === value.length - 1) {
        return v !== value[index] && v > value[index - 1];
      }

      return v !== value[index] && v < value[index + 1] && v > value[index - 1];
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", function () {
      // fix incorrect ref rect values in componentDidMount
      _this.setState({
        mounted: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "calcStep", function () {
      var step = _this.props.step;

      if (_this.validateStep(step)) {
        return step;
      } // default to 10%, 10 step to complete bar


      return step / 10;
    });

    _defineProperty(_assertThisInitialized(_this), "calcStepPercentage", function () {
      var _this$props5 = _this.props,
          step = _this$props5.step,
          max = _this$props5.max;

      if (_this.validateStep(step)) {
        return (0, _lib.convertToPercentage)(step, max);
      } // default to 10%, 10 step to complete bar


      return 10;
    });

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "knobRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "trackRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['vertical'];
      var names = [Slider.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragStart", function (e) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // fix dragging highlighted text bug
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
      var isDragging = true; // update index here

      _this.setState({
        isDragging: isDragging,
        index: index
      }, function () {
        _this.updateOffset(e);

        _this.handleCallOnDragStart(e);

        document.addEventListener('mousemove', _this.handleOnDragging, false);
        document.addEventListener('mouseup', _this.handleOnDragEnd, false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearIndex", function () {
      _this.setState({
        index: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateOffset", function (e) {
      var _this$props6 = _this.props,
          multiple = _this$props6.multiple,
          vertical = _this$props6.vertical;
      var _this$state3 = _this.state,
          knobPos = _this$state3.knobPos,
          index = _this$state3.index;
      var direction = vertical ? 'clientY' : 'clientX';

      if (multiple) {
        // add offset of current mouse cursor to correct index
        knobPos[index].offset = e[direction] - knobPos[index].pos;

        _this.setState({
          knobPos: knobPos
        });
      } else {
        // add offset of current mouse cursor
        knobPos.offset = e[direction] - knobPos.pos;

        _this.setState({
          knobPos: {
            offset: knobPos.offset,
            pos: knobPos.pos
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragging", function (e) {
      var _this$props7 = _this.props,
          smooth = _this$props7.smooth,
          multiple = _this$props7.multiple,
          vertical = _this$props7.vertical;
      var _this$state4 = _this.state,
          isDragging = _this$state4.isDragging,
          sliderInfo = _this$state4.sliderInfo,
          knobPos = _this$state4.knobPos;
      var direction = vertical ? 'clientY' : 'clientX';
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;

      if (isDragging) {
        _this.handleCallOnDragging(e);

        if (multiple) {
          _this.handleMultipleOnDragging(e);
        } else {
          // single knob
          // relative to track
          var pos = e[direction] - knobPos.offset;
          pos = _this.getPositionOnChange(pos);
          var currentPercentage = (0, _lib.convertToPercentage)(pos, sliderInfoKnobMaxValue);
          var finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage);

          var value = _this.calcValue(finalPercentage);

          if (smooth) {
            // smooth drag
            _this.setState({
              knobPos: {
                offset: knobPos.offset,
                pos: pos
              },
              highlightStyles: {
                percentage: currentPercentage
              }
            }); // only call on change if value really changed


            if (value !== _this.state.value) {
              _this.setState({
                value: value
              }, function () {
                return _this.handleCallOnChange(e);
              });
            }
          } // default snap to step


          _this.handleSnapToStep(e, currentPercentage);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMultipleOnDragging", function (e) {
      var _this$props8 = _this.props,
          smooth = _this$props8.smooth,
          vertical = _this$props8.vertical;
      var _this$state5 = _this.state,
          sliderInfo = _this$state5.sliderInfo,
          knobPos = _this$state5.knobPos,
          index = _this$state5.index;
      var direction = vertical ? 'clientY' : 'clientX';
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft; // multiple knobs
      // relative to track

      var pos = e[direction] - knobPos[index].offset;
      pos = _this.getMultiplePositionOnChange(pos, index);
      var currentPercentage = (0, _lib.convertToPercentage)(pos, sliderInfoKnobMaxValue);
      var finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage);

      var value = _this.calcValue(finalPercentage);

      if (smooth) {
        // create new array and mutate to update render
        var newPos = [].concat(knobPos);
        newPos[index].pos = pos; // last one minus first one to get total highlight width percentage

        var highlightPercentageInPx = newPos[newPos.length - 1].pos - newPos[0].pos;
        var highlightPercentage = (0, _lib.convertToPercentage)(highlightPercentageInPx, sliderInfoKnobMaxValue);

        _this.setState({
          knobPos: newPos,
          highlightStyles: {
            pos: newPos[0].pos,
            percentage: highlightPercentage
          }
        }); // only call on change if value really changed


        if (_this.validateValueOnChange(value, index)) {
          // create new array and mutate to update render
          var newValue = [].concat(_this.state.value);
          newValue[index] = value;

          _this.setState({
            value: newValue
          }, function () {
            return _this.handleCallOnChange(e);
          });
        }
      } // default snap to step


      _this.handleSnapToStep(e, currentPercentage);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragEnd", function (e) {
      var isDragging = false;

      _this.setState({
        isDragging: isDragging
      }, function () {
        _this.handleSnapToStep(e, null, true);

        _this.handleCallOnDragEnd(e);

        _this.clearIndex();

        document.removeEventListener('mousemove', _this.handleOnDragging, false);
        document.removeEventListener('mouseup', _this.handleOnDragEnd, false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSnapToStep", function (e, percentage) {
      var dragEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props9 = _this.props,
          multiple = _this$props9.multiple,
          smooth = _this$props9.smooth,
          vertical = _this$props9.vertical;
      var _this$state6 = _this.state,
          sliderInfo = _this$state6.sliderInfo,
          knobPos = _this$state6.knobPos,
          index = _this$state6.index;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;
      var currentPercentage; // use state value onDragEnd

      currentPercentage = (0, _lib.convertToPercentage)(knobPos.pos, sliderInfoKnobMaxValue);
      if (multiple) currentPercentage = (0, _lib.convertToPercentage)(knobPos[index].pos, sliderInfoKnobMaxValue);
      if (percentage) currentPercentage = percentage;
      var finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage); // default snapping left

      var pos = (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, finalPercentage);

      var value = _this.calcValue(finalPercentage);

      if (multiple) {
        if (_this.validateValueOnChange(value, index) || dragEnd) {
          if (smooth) {
            // use state value onDragEnd
            pos = _this.getMultipleSnapPosition(knobPos[index].pos);
          }

          currentPercentage = (0, _lib.convertToPercentage)(pos, sliderInfoKnobMaxValue); // if no break rules, snap to rounded value

          finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage);
          var finalPos = (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, finalPercentage);

          var finalValue = _this.calcValue(finalPercentage);

          var newPos = [].concat(knobPos);
          newPos[index].pos = finalPos; // last one minus first one to get total highlight width percentage

          var highlightPercentageInPx = newPos[newPos.length - 1].pos - newPos[0].pos;
          var highlightPercentage = (0, _lib.convertToPercentage)(highlightPercentageInPx, sliderInfoKnobMaxValue); // create new array and mutate to update render

          var newValue = [].concat(_this.state.value);
          newValue[index] = finalValue;

          _this.setState({
            value: newValue,
            knobPos: newPos,
            highlightStyles: {
              pos: newPos[0].pos,
              percentage: highlightPercentage
            }
          }, function () {
            if (!dragEnd) {
              // no need to call onChange if dragEnd
              _this.handleCallOnChange(e);
            }
          });
        }
      } else if (value !== _this.state.value || dragEnd) {
        // onDragEnd, force setState regardless of value
        _this.setState({
          value: value,
          knobPos: {
            offset: knobPos.offset,
            pos: pos
          },
          highlightStyles: {
            percentage: finalPercentage
          }
        }, function () {
          if (!dragEnd) {
            // no need to call onChange if dragEnd
            _this.handleCallOnChange(e);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTrackClick", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
      var _this$props10 = _this.props,
          multiple = _this$props10.multiple,
          vertical = _this$props10.vertical;
      var _this$state7 = _this.state,
          sliderInfo = _this$state7.sliderInfo,
          knobPos = _this$state7.knobPos;
      var direction = vertical ? 'clientY' : 'clientX';
      var trackDirection = vertical ? sliderInfo.track.top : sliderInfo.track.left;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;
      var pos = e[direction] - trackDirection;

      if (multiple) {
        _this.handleMultipleOnTrackClick(e, pos);
      } else {
        pos = _this.getPositionOnChange(pos);
        var currentPercentage = (0, _lib.convertToPercentage)(pos, sliderInfoKnobMaxValue);
        var finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage);

        var value = _this.calcValue(finalPercentage); // normal
        // only for initial click


        _this.setState({
          knobPos: {
            offset: knobPos.offset,
            pos: pos
          },
          highlightStyles: {
            percentage: currentPercentage
          }
        });

        if (value !== _this.state.value) {
          _this.setState({
            value: value
          }, function () {
            return _this.handleCallOnChange(e);
          });
        } // on drag start for normal


        _this.handleOnDragStart(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMultipleOnTrackClick", function (e, pos) {
      var vertical = _this.props.vertical;
      var _this$state8 = _this.state,
          knobPos = _this$state8.knobPos,
          sliderInfo = _this$state8.sliderInfo;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;
      var tempPos = pos; // find the nearest clicked

      var posArr = knobPos.map(function (_ref) {
        var p = _ref.pos;
        return p;
      });
      var index = (0, _lib.getNearestValueIndex)(tempPos, posArr);
      tempPos = _this.getMultiplePositionOnChange(tempPos, index);
      var currentPercentage = (0, _lib.convertToPercentage)(tempPos, sliderInfoKnobMaxValue);
      var finalPercentage = (0, _lib.getMultiplierRounded)(currentPercentage, sliderInfo.step.percentage);

      var value = _this.calcValue(finalPercentage); // only for initial click
      // create new array and mutate to update render


      var newPos = [].concat(knobPos);
      newPos[index].pos = tempPos; // last one minus first one to get total highlight width percentage

      var highlightPercentageInPx = newPos[newPos.length - 1].pos - newPos[0].pos;
      var highlightPercentage = (0, _lib.convertToPercentage)(highlightPercentageInPx, sliderInfoKnobMaxValue);

      _this.setState({
        knobPos: newPos,
        highlightStyles: {
          pos: newPos[0].pos,
          percentage: highlightPercentage
        }
      });

      if (_this.validateValueOnChange(value, index)) {
        // create new array and mutate to update render
        var newValue = [].concat(_this.state.value);
        newValue[index] = value;

        _this.setState({
          value: newValue
        }, function () {
          return _this.handleCallOnChange(e);
        });
      } // on drag start with the nearest index


      _this.handleOnDragStart(e, index);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCallOnChange", function (e) {
      var _this$props11 = _this.props,
          name = _this$props11.name,
          onChange = _this$props11.onChange;
      var value = _this.state.value;

      if (onChange) {
        onChange(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCallOnDragging", function (e) {
      var _this$props12 = _this.props,
          name = _this$props12.name,
          onDragging = _this$props12.onDragging;
      var value = _this.state.value;

      if (onDragging) {
        onDragging(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCallOnDragStart", function (e) {
      var _this$props13 = _this.props,
          name = _this$props13.name,
          onDragStart = _this$props13.onDragStart;
      var value = _this.state.value;

      if (onDragStart) {
        onDragStart(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCallOnDragEnd", function (e) {
      var _this$props14 = _this.props,
          name = _this$props14.name,
          onDragEnd = _this$props14.onDragEnd;
      var value = _this.state.value;

      if (onDragEnd) {
        onDragEnd(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnInputChange", function (e, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      var multiple = _this.props.multiple;

      if (multiple) {
        var index = name;

        if (index >= 0) {
          // handle multiple input value change
          _this.setState({
            index: index
          }, function () {
            _this.updateMultipleValue(e, value);
          });
        }
      } else if (_this.validateValue(value)) {
        // normal
        _this.setState({
          value: value
        }, function () {
          _this.updateValue();

          _this.handleCallOnChange(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateValue", function () {
      var _this$props15 = _this.props,
          max = _this$props15.max,
          vertical = _this$props15.vertical;
      var _this$state9 = _this.state,
          value = _this$state9.value,
          sliderInfo = _this$state9.sliderInfo,
          knobPos = _this$state9.knobPos;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;
      var currentPercentage = (0, _lib.convertToPercentage)(value, max);
      var pos = (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, currentPercentage);

      _this.setState({
        knobPos: {
          offset: knobPos.offset,
          pos: pos
        },
        highlightStyles: {
          percentage: currentPercentage
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateMultipleValue", function (e, value) {
      var _this$props16 = _this.props,
          max = _this$props16.max,
          vertical = _this$props16.vertical;
      var _this$state10 = _this.state,
          index = _this$state10.index,
          knobPos = _this$state10.knobPos,
          sliderInfo = _this$state10.sliderInfo;
      var sliderInfoKnobMaxValue = vertical ? sliderInfo.knob.maxTop : sliderInfo.knob.maxLeft;

      if (_this.validateValueOnChange(value, index)) {
        var currentPercentage = (0, _lib.convertToPercentage)(value, max);
        var pos = (0, _lib.getPercentageValue)(sliderInfoKnobMaxValue, currentPercentage); // create new array and mutate to update render

        var newPos = [].concat(knobPos);
        newPos[index].pos = pos; // last one minus first one to get total highlight width percentage

        var highlightPercentageInPx = newPos[newPos.length - 1].pos - newPos[0].pos;
        var highlightPercentage = (0, _lib.convertToPercentage)(highlightPercentageInPx, sliderInfoKnobMaxValue); // create new array and mutate to update render

        var newValue = [].concat(_this.state.value);
        newValue[index] = value;

        _this.setState({
          knobPos: newPos,
          highlightStyles: {
            pos: newPos[0].pos,
            percentage: highlightPercentage
          },
          value: newValue
        }, function () {
          _this.clearIndex();

          _this.handleCallOnChange(e);
        });
      }
    });

    var _value = _this.getInitValue(_this.props.value);

    _this.state = {
      value: _value,
      isDragging: false,
      sliderInfo: null,
      knobPos: null,
      // stores variables, offset and position of knobs
      highlightStyles: {},
      index: null,
      mounted: false
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted(); // add resize listener to update slider on window resize

      window.addEventListener('resize', this.getInitInfo, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var mounted = this.state.mounted;

      if (prevState.mounted !== mounted) {
        this.getInitInfo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove listener
      window.removeEventListener('resize', this.getInitInfo, false);
      document.removeEventListener('mousemove', this.handleOnDragging, false);
      document.removeEventListener('mouseup', this.handleOnDragEnd, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props17 = this.props,
          children = _this$props17.children,
          innerRef = _this$props17.innerRef,
          smooth = _this$props17.smooth,
          step = _this$props17.step,
          min = _this$props17.min,
          max = _this$props17.max,
          multiple = _this$props17.multiple,
          vertical = _this$props17.vertical,
          onDragging = _this$props17.onDragging,
          onDragStart = _this$props17.onDragStart,
          onDragEnd = _this$props17.onDragEnd,
          onChange = _this$props17.onChange,
          rest = _objectWithoutProperties(_this$props17, ["children", "innerRef", "smooth", "step", "min", "max", "multiple", "vertical", "onDragging", "onDragStart", "onDragEnd", "onChange"]);

      var classNames = this.classNames();
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var ref = innerRef || this.innerRef;
      var context = {
        onChange: this.handleCallOnChange,
        onDragStart: this.handleOnDragStart,
        onTrackClick: this.handleOnTrackClick,
        onInputChange: this.handleOnInputChange,
        knobPos: this.state.knobPos,
        highlightStyles: this.state.highlightStyles,
        value: this.state.value,
        knobRef: this.knobRef,
        trackRef: this.trackRef,
        step: this.calcStep(),
        vertical: vertical,
        min: min,
        max: max,
        multiple: multiple,
        ref: ref
      };
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        ref: ref,
        className: classNames
      }), _react.default.createElement(SliderContext.Provider, {
        value: context
      }, children));
    }
  }]);

  return Slider;
}(_react.PureComponent);

exports.default = Slider;

_defineProperty(Slider, "Bar", (0, _withSliderContext.default)(_Bar.default));

_defineProperty(Slider, "Input", (0, _withSliderContext.default)(_Input.default));

_defineProperty(Slider, "className", 'MHub-Slider');

_defineProperty(Slider, "propTypes", {
  children: _propTypes.default.node.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragging: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  smooth: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  innerRef: _common.customPropTypes.ref
});

_defineProperty(Slider, "defaultProps", {
  value: null,
  name: null,
  onChange: null,
  onDragStart: null,
  onDragging: null,
  onDragEnd: null,
  min: null,
  max: null,
  step: null,
  smooth: false,
  multiple: false,
  vertical: false,
  innerRef: null
});